'use client';

import React from 'react';

import Image from 'components/nextjs-fixes/image';

import { styles } from '.';

type TProps = {
  picture: any;
  onClick: () => void;
};

const PictureItem = (props: TProps) => {
  const { picture, onClick } = props;

  if (!picture?.asset?.url) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.figure}>
        <Image
          src={picture?.asset?.url ?? ''}
          alt={picture?.alternativeText ?? 'picture-item'}
          className={styles.image}
          fill
          onClick={onClick}
        />
      </div>
    </div>
  );
};

export default PictureItem;
